import { db } from "@/utils/firebase";
import { getUser } from "@/hooks/useLocalStorage";
import { query, where, orderBy, collection, getDocs } from "firebase/firestore";

const getSellerRequests = async () => {
  try {
    const user = getUser();

    // Reference to the 'seller_requests' collection
    const sellerRequestsRef = collection(db, "seller_requests");

    // Query to find documents where 'user_id' matches the provided uid
    const q = query(
      sellerRequestsRef,
      where("user_id", "==", user.uid),
      orderBy("created_at", "desc") // Sort by created_at in descending order
    );

    // Get the documents from Firestore
    const querySnapshot = await getDocs(q);

    // If there are no matching documents, return an empty array
    if (querySnapshot.empty) {
      return [];
    }

    // Map through the documents and return the data with the converted Date for created_at
    const sellerRequests = querySnapshot.docs.map((doc) => {
      const data = doc.data();

      return {
        ...data,
        created_at: data.created_at.toDate().toISOString(),
      };
    });

    return sellerRequests;
  } catch (error) {
    console.error("Error fetching seller requests:", error);
    throw new Error("Failed to fetch seller requests");
  }
};

export default getSellerRequests;
